import * as MUI from "@mui/material";
import { Link } from "react-router-dom";

type Inputs = {
  infoName: string;
  infoMae: string;
  infoPai: string;
  to: string;
};

export const ResultadoConsultaCivil: React.FC<Inputs> = ({
  infoName,
  infoMae,
  infoPai,
  to,
}) => {
  return (
    <MUI.Paper
      component={Link}
      elevation={5}
      to={to}
      sx={{
        display: "flex",
        mb: 2,
      }}
    >
      <MUI.CardActionArea>
        <MUI.Stack
          display="flex"
          width="100%"
          flexDirection={["column", "row"]}
          p={0.5}
          gap={[0, 2]}
        >
          <MUI.Stack>
            <MUI.Divider
              orientation="vertical"
              sx={{
                borderWidth: 3.2,
                backgroundColor: "blue",
              }}
            />
          </MUI.Stack>
          <MUI.Stack flex={1}>
            <MUI.Typography variant="body2" fontWeight="bold">
              Nome
            </MUI.Typography>
            <MUI.Typography variant="caption">{infoName}</MUI.Typography>
          </MUI.Stack>

          <MUI.Stack flex={1}>
            <MUI.Typography variant="body2" fontWeight="bold">
              Nome mãe
            </MUI.Typography>
            <MUI.Typography variant="caption">{infoMae}</MUI.Typography>
          </MUI.Stack>

          <MUI.Stack flex={1}>
            <MUI.Typography variant="body2" fontWeight="bold">
              Nome pai
            </MUI.Typography>
            <MUI.Typography variant="caption">{infoPai}</MUI.Typography>
          </MUI.Stack>
        </MUI.Stack>
      </MUI.CardActionArea>
    </MUI.Paper>
  );
};
